<template>
    <div>
        {{id}}
    <ApolloQuery
                :query="require('./getPartner.query.gql')"
                :variables="{id:id}"
                fetchPolicy="no-cache"
              >
                <template slot-scope="{ result: { data, loading,error } }">
          <div v-if="loading">Loading...</div>
           <!-- Error -->
  <div v-else-if="error" class="error apollo">An error occurred</div>
         <div v-else-if="data"> 
               <el-card
            shadow="always"
            :body-style="{ background: '#f5f5f5' }"
       
          >   
             <h2>{{data.partner_by_pk.name}}</h2>
<el-form >

                <el-upload
                class="upload-demo"
                label="Logo"
                ref="upload"
                :data="{partner:data.partner_by_pk.name}"
                :on-success="handleAvatarSuccess"
                :show-file-list="false"
                :before-upload="beforeAvatarUpload"
                   :headers="headerInfo"
                :action="serverURL+'/user/upload'"
                >
                <el-button slot="trigger" size="small" type="primary">select file</el-button>
          
                <div class="el-upload__tip" slot="tip">jpg/png files with a size less than 500kb</div>
              </el-upload>
              <el-form-item label="Options">
 <el-checkbox v-model="data.partner_by_pk.cobranded">Co-Branded</el-checkbox>
<el-checkbox v-model="data.partner_by_pk.certificates">Certificates</el-checkbox>

</el-form-item>
  <el-form-item label="Enrollment Email Template">
              <el-input placeholder="Name" v-model="data.partner_by_pk.enrol_email_template" />
              <small>This is the mailchimp template name gets sent to mandrill. </small>
  </el-form-item> 
       <el-form-item label="Send copy of enrolment to:">
              <el-input placeholder="Name" v-model="data.partner_by_pk.emailcc" />
  </el-form-item>
    <el-form-item label="Pass Email Template">
              <el-input placeholder="Name" v-model="data.partner_by_pk.pass_email_template" />
              <small>This is the mailchimp template name gets sent to mandrill. </small>
  </el-form-item> 
          <el-form-item label="Send copy of pass to:">
              <el-input placeholder="Name" v-model="data.partner_by_pk.passcc" />
  </el-form-item>
    <el-form-item label="Course Player Url">
              <el-input placeholder="Name" v-model="data.partner_by_pk.entry_url" />
  </el-form-item>
    <el-form-item label="Certificate Template">
              <el-input placeholder="Name" v-model="data.partner_by_pk.cert_pdf_template" />
  </el-form-item>
    <el-form-item label="Certificate Email">
              <el-input placeholder="Name" v-model="data.partner_by_pk.cert_email_template" />
  </el-form-item>
    <el-form-item>
        <el-button type="info" @click="doUpdate(data.partner_by_pk)">Update</el-button>
      </el-form-item>
  
</el-form>
               </el-card>
             {{data}}</div>
     
                </template>
    </ApolloQuery>
    </div>
</template>

<script>
import gql from 'graphql-tag'
export default {
    data() {
        

        return {
          data:{},
            id:null,
                 headerInfo: {
        'x-path': 'avatars/',
        'Authorization':'Bearer '+window.localStorage.getItem('jwt_token')
      },
            serverURL: "http://localhost:3000"}
    },
    methods:{
 async doUpdate(data){
console.log(data)
this.$apollo.mutate({
mutation:gql`mutation MyMutation($id: Int!) {
  update_partner_by_pk(pk_columns: {id: $id}, _set: {cobranded: ${data.cobranded}, certificates: ${data.certificates}, emailcc: "${data.emailcc}", enrol_email_template: "${data.enrol_email_template}", entry_url: "${data.entry_url}", passcc: "${data.passcc}", logo_url: "${data.logo_url}", pass_email_template: "${data.pass_email_template}", cert_pdf_template: "${data.cert_pdf_template}",, cert_email_template: "${data.cert_email_template}"}) {
    id
  }
}`,
 // Parameters
      variables: {
        id: this.id,
      },


}).then((data) => {
      // Result
      console.log(data)
    }).catch((error) => {
      // Error
      console.error(error)
      // We restore the initial user input
      this.newTag = newTag
    })
          
      },
 submitUpload() {
      this.$refs.upload.submit();
    },

    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
        const q = gql`
        mutation update_employee($id: Int, $avatar:String!) {
          update_Employee(where: { id: { _eq: $id } }, _set:  {avatar: $avatar}) {
            affected_rows
            returning {
              id
              
            }
          }
        }
      `;
        this.$apollo
        .mutate({
          mutation: q,
          variables: {
            id: this.userInfo.id,
           avatar:res[0]
          }
        })
        .then(result => {
       this.$store.dispatch(USER_REQUEST);
          this.$notify({
            title: "Updated",
            message: "Avatar Updated",
            type: "success"
          });
        })
        .catch(error => {
          this.$notify({
            title: "Error",
            message: error.message,
            type: "error"
          });
        });
    },
    beforeAvatarUpload(file) {
      console.log('before',file)
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('Avatar picture must be JPG or PNG format!');
      }
      if (!isLt2M) {
        this.$message.error('Avatar picture size can not exceed 2MB!');
      }
      return isJPG && isLt2M;
    }
  },


   
      mounted() {
    this.id=this.$route.params.id

  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Partner/Edit.vue